/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const SelfieIcon = ({ color = 'currentColor', ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
    data-palette="SelfieIcon">
    <path
      stroke={color}
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.556 1H2.778A1.778 1.778 0 0 0 1 2.778v1.778M13.444 1h1.778A1.778 1.778 0 0 1 17 2.778v1.778m-4.444.888v1.778M5.444 5.444v1.778m.89 5.334s.888.888 2.666.888 2.667-.888 2.667-.888M9 5.444V9.89h-.889M4.556 17H2.778A1.778 1.778 0 0 1 1 15.222v-1.778M13.444 17h1.778A1.778 1.778 0 0 0 17 15.222v-1.778"
    />
  </svg>
);
export default SelfieIcon;
